<template>
  <div v-if="commission" class="commission custom-modal">
    <div class="custom-modal-header">
      <div class="close-modal">
        <i class="bx bx-x" @click="closeModal"></i>
      </div>
      <div class="title text-white">
        COMMISSION DETAILS
      </div>
    </div>
    <div class="modal-body">
      <div class="d-flex">
        <div>
          <p>Commission Type</p>
          <h4>{{ commission.orderId ? 'Purchased' : 'Sold' }} for Client</h4>
        </div>
      </div>
      <div class="d-flex">
        <div>
          <p>{{ commission.orderId ? 'Purchased' : 'Received' + ' on' }}</p>
          <h4>{{ commission.createdAt }}</h4>
        </div>
        <div class="ml-5">
          <p>Paid On</p>
          <h4>{{ commission.paidAt ? commission.paidAt : 'Pending' }}</h4>
        </div>
      </div>
      <div class="d-flex">
        <div>
          <p>Payout to {{ client.firstName }}</p>
          <h4>{{ currency(product.attributes.purchasePrice) }}</h4>
        </div>
        <div class="ml-5">
          <p>Your Commission</p>
          <h4>{{ currency(commission.amount) }}</h4>
        </div>
      </div>
      <thumbnail-row
        :rowMain="'<p class=\'text-white small\'>Client</p><h5 class=\'text-white\'>' + client.firstName + ' ' + client.lastName + '</h5>'"
        :initials="client.initials"
        :thumbnailUrl="client.thumbnailUrl">
      </thumbnail-row>
      <div class="text-center">
        <img class="img-thumbnail" v-bind:src="product.attributes.thumbnailUrl">
      </div>
      <div class="d-flex">
        <div>
          <h4 class="text-uppercase">{{ product.attributes.brand }}</h4>
        </div>
        <div class="text-right">
          <p class="small">{{ product.id }}</p>
        </div>
      </div>
      <div>
        <p>{{ product.attributes.titleWithoutBrand }}</p>
      </div>
      <div>
        <p class="text-uppercase mt-3"><strong>STATUS UPDATES</strong></p>
        <div class="d-flex text-white small mb-1" v-for="(statusData, key) in commission.statuses" v-html='getStatuses(statusData)' v-bind:key="key"></div>
      </div>
    </div>
  </div>
  <commission-loading v-else />
</template>
<script>
import api from '@/services/api'
import ThumbnailRow from '@/components/shared/thumbnail-row'
import CommissionLoading from './commission-loading'
export default {
  components: { ThumbnailRow, CommissionLoading },
  name: 'commission',
  props: ['commissionId'],
  data () {
    return {
      commission: '',
      client: '',
      product: '',
      commissionData: ''
    }
  },
  methods: {
    currency (amount) {
      return this.$helpers.currency(amount)
    },
    getStatuses (statusData) {
      const date = Object.keys(statusData)[0]
      const status = statusData[date]

      return '<div>' + date + '</div><div class="ml-3">' + status + '</div>'
    },
    getCommission () {
      const commissionId = this.getCommissionId()
      const self = this
      return api.get('/api/stylist/commissions/' + commissionId + '?include=product').then(response => {
        this.commissionData = response.data
        this.commission = this.commissionData.data.attributes
        this.client = self.$store.state.clients.find(client => client.id === this.commission.clientId)
        this.product = this.commissionData.included.find(relation => relation.type === 'product')
      })
    },
    getCommissionId () {
      if (this.$route.params.id) {
        return this.$route.params.id
      } else {
        return this.commissionId
      }
    },
    closeModal () {
      this.$bvModal.hide('commission-modal')
    }
  },
  mounted () {
    this.getCommission()
  }
}
</script>

<style scoped>
  .commission p, .commission h4, .commission label {
    color: #FFF;
  }
  .commission p {
    font-size: 10px;
    margin-bottom: 3px;
  }

  .commission h4 {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .commission .d-flex div {
    width: 50%;
  }

  .commission .text-uppercase {
    margin-bottom: 5px;
  }

  .commission .img-thumbnail {
    max-width: 150px;
    margin-bottom: 10px;
  }
</style>
